import { ContactBlock as ContactBlockModel } from 'models/ContactSection';
import styles from './styles.scss';
import { IconPhone } from 'components/Shared/Icon/themes/BGH-RD3/iconPhone';
import { Button } from 'components/Button';

export const PhoneButton = ({ phoneNumber }: Pick<ContactBlockModel, 'phoneNumber'>) => {
  return (
    <Button appearance="primary" href={`tel:${phoneNumber}`} className={styles.phoneButton}>
      <IconPhone className={styles.phoneIcon} />
      <span>{phoneNumber}</span>
    </Button>
  );
};
